export default __webpack_public_path__ + "static/media/T5WInfographics3.2103f6c555c7f51a8db41f1a5f5a39fb.png";